import { useTranslation } from 'react-i18next';

import { formatDate } from '@virtual-care/isomorphic';
import { Button, CardFooter } from '@virtual-care/shadcn';

interface AppointmentTimeFooterProps {
  datetime?: string | Date;
  onBack: () => void;
  onContinue: () => void;
}

const AppointmentTimeFooter = ({
  datetime,
  onBack,
  onContinue,
}: AppointmentTimeFooterProps) => {
  const { t } = useTranslation();
  return (
    <CardFooter className="flex flex-col items-start gap-4 border-t px-6 md:flex-row md:items-center">
      <div className="flex-1/3 text-sm">
        {datetime
          ? formatDate(datetime)
          : t('booking.appointmentTime.pickDate')}
      </div>
      <div className="flex w-full flex-2/3 flex-col gap-4 md:flex-row">
        <Button
          type="button"
          variant={'outline'}
          onClick={onBack}
          className="secondary-button w-full"
        >
          {t('booking.appointmentTime.back')}
        </Button>
        <Button
          variant={'default'}
          disabled={!datetime}
          onClick={onContinue}
          className="primary-button w-full bg-green-600 hover:bg-green-700"
        >
          {t('booking.appointmentTime.continue')}
        </Button>
      </div>
    </CardFooter>
  );
};

export default AppointmentTimeFooter;
